const updatesData = [
  {
    date: '2024.07.28',
    title: '《你比星光美丽》大结局上线',
    desc: '谭松韵许凯主演的都市甜宠剧全集更新完毕，情侣影院同步上线大结局，会员可第一时间观看。',
    tag: '剧集更新',
  },
  {
    date: '2024.07.25',
    title: '韩剧《眼泪女王》全集中字完整版',
    desc: '金秀贤金智媛主演的口碑韩剧全集已上线，高清中文字幕版本，情侣追剧必看佳作。',
    tag: '韩剧上新',
  },
  {
    date: '2024.07.22',
    title: '情侣影院片库突破2000部',
    desc: '平台电视剧全集收录数量正式突破2000部，覆盖国产剧、韩剧等多元类型，持续丰富内容生态。',
    tag: '平台动态',
  },
  {
    date: '2024.07.18',
    title: '暑期追剧专题「甜蜜一夏」上线',
    desc: '精选50部高甜恋爱剧集组成暑期专属片单，涵盖国产剧和韩剧，夏日追剧不剧荒。',
    tag: '专题活动',
  },
  {
    date: '2024.07.14',
    title: '播放体验全面升级，支持1080P',
    desc: '情侣影院全站剧集已升级至1080P高清画质，观影体验全面优化，追剧更清晰流畅。',
    tag: '功能更新',
  },
  {
    date: '2024.07.10',
    title: '《与凤行》全集上线，赵丽颖林更新',
    desc: '古装仙侠大剧全集已完整上线，高清画质双语字幕，情侣一起追仙侠不容错过。',
    tag: '剧集更新',
  },
  {
    date: '2024.07.05',
    title: '悬疑剧场扩建，新增50部高分刑侦剧',
    desc: '情侣影院悬疑剧场大幅扩建，新增多部豆瓣高分刑侦剧全集，和TA一起烧脑推理。',
    tag: '内容扩充',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-10 gap-4">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-800 mb-2">
              最新动态
            </h2>
            <p className="text-foreground-500 text-sm">平台最新剧集上线、功能更新和活动资讯</p>
          </div>
        </div>

        <div className="relative">
          <div className="absolute left-[19px] top-2 bottom-2 w-px bg-secondary-200 hidden md:block"></div>

          <div className="space-y-6">
            {updatesData.map((item, idx) => (
              <div key={idx} className="relative flex gap-6">
                <div className="hidden md:flex flex-shrink-0 w-10 h-10 rounded-full bg-primary-500 items-center justify-center z-10">
                  <i className="ri-time-line text-white text-sm"></i>
                </div>
                <div className="flex-1 bg-background-100 rounded-xl p-5 border border-secondary-200/70">
                  <div className="flex flex-col sm:flex-row sm:items-center gap-2 mb-2">
                    <span className="text-xs text-foreground-400">{item.date}</span>
                    <span className="hidden sm:block text-foreground-300">·</span>
                    <span className="px-2 py-0.5 rounded bg-accent-100 text-accent-700 text-xs font-medium w-fit">
                      {item.tag}
                    </span>
                  </div>
                  <h3 className="font-heading text-base font-bold text-foreground-800 mb-2">{item.title}</h3>
                  <p className="text-foreground-500 text-sm leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}